import { registerBlockType } from '@wordpress/blocks';
import { registerBlockVariation } from '@wordpress/blocks';
import { Swiper } from 'swiper';

import { Blog } from './blog.js';
import { Gallery } from './gallery.js';
import { Modal } from './modal.js';
import { copyToClipboard } from './helpers.js';

window.activeCssClass = acseoPlugin.activeCssClass;
window.Blog = Blog;
window.Gallery = Gallery;
window.Swiper = Swiper;
window.Modal = Modal;
window.copyToClipboard = copyToClipboard;

const blockKeys = [
    'blog', 
    'blog-filters-alone',
    'header',
    'footer',
];

blockKeys.forEach((key) => {
  const config = require(`./views/blocks/${key}/block.json`);
  const registerKey = 'acf/' + key;
  registerBlockType(registerKey, config);
});

registerBlockVariation( 
  'core/embed', 
  {
      name: 'custom-embed',
      attributes: { providerNameSlug: 'custom' },
  }
);
